import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { EntityWithCommentsCollapsing } from '@sb-tools/typescript/models/entity-with-comments-collapsing.model';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'lastSubReply' })
// subRepliesLength? - needed to make pipe called when subreplies array is changed
export class LastSubReplyPipe implements PipeTransform {
    transform(
        subReplies,
        parent: EntityWithCommentsCollapsing,
        areCommentsShown,
        subRepliesLength?,
        isPrinting = false,
    ): any {
        if (!subRepliesLength) {
            return [];
        }

        if (areCommentsShown || subReplies.length === 1 || isPrinting) {
            return subReplies;
        }

        const sliceStart = subReplies.length - 1;
        const lessSubReplies = subReplies.slice(sliceStart);

        parent.commentsCountForExpander = subReplies.length - lessSubReplies.length;

        return lessSubReplies;
    }
}
